import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import {
  Button,
  StandardDialog,
  createCurrencyField,
  createSelectField,
} from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';

export interface EditTaxModalProps {
  open: boolean;
  onClose: () => void;
  editingTaxIndex: number | null;
}

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: 0,
  },
  closeButton: {
    border: '1px solid #D0D0D0',
    color: theme.palette.text.primary,
    textTransform: 'none',
    fontWeight: 600,
    width: 120,
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
  saveButton: {
    textTransform: 'none',
    fontWeight: 600,
    width: 120,
  },
}));

export const EditTaxModal = observer(
  ({ open, onClose, editingTaxIndex }: EditTaxModalProps) => {
    const classes = useStyles();
    const { titleCommitmentStore } = useStore();
    const store = titleCommitmentStore.taxFormStore;

    const propertyOptions = [
      { label: 'Please Select', value: '' },
      ...titleCommitmentStore.loanProperties.map(p => ({
        label: p.fullAddress,
        value: String(p.propertyId),
      })),
    ];

    const dialogContent = (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {createSelectField({
            store,
            fieldName: 'propertyId',
            testId: 'propertyId',
            label: 'Property',
            options: propertyOptions,
          })}
        </Grid>
        <Grid item xs={12}>
          {createCurrencyField({
            store,
            fieldName: 'annualTaxAmount',
            testId: 'annualTaxAmount',
            label: 'Annual Tax Amount',
          })}
        </Grid>
      </Grid>
    );

    const handleSave = async () => {
      await titleCommitmentStore.saveTaxRecord(editingTaxIndex);
      onClose();
    };

    const dialogActions = (
      <>
        <Button
          className={classes.closeButton}
          variant="outlined"
          onClick={onClose}
          testId="edit-tax-cancel"
        >
          Cancel
        </Button>
        <Button
          className={classes.saveButton}
          variant="contained"
          color="primary"
          onClick={handleSave}
          testId="edit-tax-save"
        >
          Save
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        title="Edit Property Tax"
        maxWidth="sm"
        fullWidth
        handleClose={onClose}
        dialogContent={dialogContent}
        dialogActions={dialogActions}
        dialogContentclasses={{ root: classes.dialogContent }}
      />
    );
  }
);
